import DesktopBg from "@/assets/images/desktop-profile-bg.png";
import { useGlobalStore } from "@/store/GlobalStore";
import { getTranslateNsT } from "@/utils/getTranslateNsT";
import {
  Bg,
  Card,
  Cumulative,
  Label,
  LabelWrapper,
  RechargeButton,
  Value,
  ValueWrapper,
  Wrapper,
} from "./atoms";
import { formatCurrency } from "project-config/utils";

export function DesktopChargeCard() {
  const { isSubAccount, userDesktopInfo } = useGlobalStore();
  const t = getTranslateNsT("profile");
  const {
    availableAmount = 0,
    subAvailableAmount = 0,
    cumulative = 0,
  } = userDesktopInfo || {};

  const toTopUp = (activeName?: string) => {
    const basename =
      process.env.NODE_ENV === "development" ? "/topUp" : "/center/user/topUp";
    window.open(
      activeName ? `${basename}?activeName=${activeName}` : basename,
      "_blank"
    );
  };
  return (
    <Wrapper>
      <Card>
        <Bg src={DesktopBg} />
        <div>
          <LabelWrapper>
            {!isSubAccount && (
              <Label>{t("main_account_desktop_balance")}</Label>
            )}
            <Label gap={!isSubAccount}>
              {t("sub_account_desktop_balance")}
            </Label>
          </LabelWrapper>
          <ValueWrapper>
            <Value>
              <span className="unit">¥</span>
              <span className="value">
                {formatCurrency(
                  isSubAccount ? subAvailableAmount : availableAmount
                )}
              </span>
            </Value>
            {!isSubAccount && (
              <Value gap>
                <span className="unit">¥</span>
                <span className="value">
                  {formatCurrency(subAvailableAmount)}
                </span>
              </Value>
            )}
          </ValueWrapper>
        </div>
        {!isSubAccount && (
          <>
            <Cumulative>
              <span>{t("desktop_cumulative_recharge")}</span>
              <span className="unit">¥</span>
              <span className="value">{cumulative}</span>
            </Cumulative>
            <RechargeButton
              onClick={() => {
                toTopUp("desktop-recharge");
              }}
            >
              <span>充值</span>
            </RechargeButton>
          </>
        )}
      </Card>
    </Wrapper>
  );
}
